import React, {useMemo} from 'react';
import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import {SaltusAny} from '../../utils/SaltusAny';

type dropdownValue = {
  simplifiedName?: string;
  name: string;
  id: string;
};

// export default function GenericDropdown({value, onChange, list, loading, label, error}) {
const GenericDropdown: React.FC<{
  value: dropdownValue | string;
  onChange: (val: SaltusAny) => SaltusAny;
  loading: boolean;
  label: string;
  error?: null | string;
  list: dropdownValue[];
}> = ({label, loading = false, onChange, value, error, list}) => {
  // export default function GenericDropdown({value, onChange, list, loading, label, error}) {
  const renderValue = () =>
    typeof value === 'string' ? value : value?.simplifiedName || value?.name;

  const menuItems = useMemo(
    () =>
      list?.map((item) => (
        <MenuItem value={item?.id} key={item?.id}>
          <Typography>
            {item?.simplifiedName ||
              item?.name ||
              `ID: ${item?.id}` ||
              JSON.stringify(item)}
          </Typography>
        </MenuItem>
      )),
    [list]
  );
  const onInputChange = (event: SaltusAny) => {
    const val = event?.target?.value;
    onChange(list?.find((g) => g.id === val));
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <FormControl
      required
      sx={{
        '& .MuiInputBase-root': {
          minWidth: '10rem',
        },
      }}
      error={!!error}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={typeof value === 'string' ? value : value?.id || value?.name}
        renderValue={renderValue}
        onChange={onInputChange}
        input={<Input />}
        autoWidth
        defaultValue={typeof value === 'string' ? value : value?.id}
      >
        {menuItems}
      </Select>
    </FormControl>
  );
};

export default GenericDropdown;
